import React from 'react';
import { useNavigate } from 'react-router';
import { Box, Stack, Typography } from '@mui/material';

import { Link, Logo, Spinner } from '@barboxx/admin-components';
import { useAuth } from '@barboxx/admin-utils';

import { Footer, RootContainer } from '../StyledComponents';

export default function Logout() {
    const { initializing, logout } = useAuth();
    const navigate = useNavigate();

    React.useEffect(() => {
        const handleLogout = async () => {
            await logout();
            navigate('/login');
        };

        handleLogout();
    }, [logout, navigate]);

    return (
        <RootContainer maxWidth="xs">
            <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                gap={2}
            >
                <Logo />
                <Typography
                    margin={2}
                    variant="h4"
                    align="center"
                    color="textPrimary"
                >
                    Logging out
                </Typography>

                {initializing && (
                    <Stack height={240} justifyContent="center">
                        <Spinner />
                    </Stack>
                )}

                <Footer>
                    <Typography color="textPrimary" variant="body2">
                        Return to <Link to="/signup">Login</Link>
                    </Typography>
                </Footer>
            </Box>
        </RootContainer>
    );
}
